export default {
  alert: 'Pro <b>urychlení žádosti</b> <br/> můžete nahrát dokumenty.',
  dropbox: {
    text: 'Vložte daňové přiznání, faktury, fotky nemovitostí',
    hint: '<b>Přetáhnutím</b> nebo <b>kliknutím</b> nahrajete soubory',
  },
  uploader: {
    label: 'Nahrávání souborů...',
  },
};
